import { memo, useState } from 'react';

import { RangePicker } from '@/entities/range-picker';
import { GrafanaRangePicker } from '@/features/grafana-range-picker';
import { useMatchMedia } from '@/shared/lib/hooks/use-match-media.hook';
import { Box } from '@/shared/ui/box';

import { PageDatePickerProps } from './page-date-picker.types';

const PageDatePickerComponent = ({
	children,
	showTimeInput = false,
	isGrafanaRangePicker = false,
}: PageDatePickerProps) => {
	const [from, setFrom] = useState<Date>();
	const [to, setTo] = useState<Date>();

	const isTabletAndLaptop = useMatchMedia('tabletAndLaptop');
	const isMobile = useMatchMedia('mobile');

	return (
		<>
			<Box padding={isTabletAndLaptop ? '0 18px 0 0' : '0'} justify={isGrafanaRangePicker ? 'flex-end' : 'flex-start'}>
				{isGrafanaRangePicker && (
					<GrafanaRangePicker
						startDate={from}
						onChangeStartDate={setFrom}
						endDate={to}
						onChangeEndDate={setTo}
						margin="-16px 0 16px"
					/>
				)}
				{!isGrafanaRangePicker && (
					<RangePicker
						startDate={from}
						onChangeStartDate={setFrom}
						endDate={to}
						onChangeEndDate={setTo}
						showTimeInput={showTimeInput}
						flexWrap={isMobile ? 'wrap' : 'nowrap'}
					/>
				)}
			</Box>
			{children(from, to)}
		</>
	);
};

export default memo(PageDatePickerComponent);
